
import request from '@/axios/personalCenter'

// A-21-我的选材单
export function orderSelection(data) {
  return request({
    url: process.env.VUE_APP_CENTER_API + '/ucenter/order/selection',
    method: 'post',
    data
  })
}

